import React, { useEffect, useState } from 'react';
import _ from 'lodash';

import { FormattedMessage, injectIntl } from 'react-intl';

import Button from '@material-ui/core/Button';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import NearMeIcon from '@material-ui/icons/NearMe';
import BusinessIcon from '@material-ui/icons/Business';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

import auth from 'app/api/auth';

import { useDispatch, useSelector } from 'react-redux';
import { setFromLogin, showLoading, hideLoading } from 'app/store/slices/settings';

import { URLS } from 'app/config/urls';
import { Formik, Form, Field } from 'formik';
import { Box, Grid, FormControl, InputLabel, Select } from '@material-ui/core';
import { clearServices } from 'app/store/slices/services';
import { logOut } from 'app/store/slices/user';
import { setActiveCompany } from 'app/store/slices/company';
import { errorHandler } from 'app/utils/errorHandler';

import companyEndpoints from 'app/api/services/companyEndpoints';

import styles from './styles';
const useStyles = makeStyles(styles);

function SelectCompany(props) {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const [companies, setCompanies] = useState([]);
  const [companySelected, setCompanySelected] = useState({});
  const [loading, setLoading] = useState(true);

  const user = useSelector(state => state.auth.user);

  const logo = process.env.PUBLIC_URL + '/img/logo-login.png';

  useEffect(() => {
    if (!auth.getToken()) {
      dispatch(setFromLogin(true));
      history.push(URLS.START);
    }
    if (!user.empresas || user.empresas.length === 0 || user.empresas.length === 1) {
      history.push(URLS.START);
    } else {
      setLoading(false);
      setCompanies(user.empresas);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSelectCompany = async companyParam => {
    dispatch(showLoading());
    let company = companyParam ? companyParam : companySelected;
    try {
      const response = await companyEndpoints.getCompany({ cdEmpresa: company.cdEmpresa });
      if (response.status === 200 && response.data) {
        await companyEndpoints.setSelectedCompany(company.cdEmpresa);
      }
    } catch (error) {
      errorHandler(error.response?.status, error.response?.data?.message);
    }
    await dispatch(setActiveCompany(company));
    dispatch(hideLoading());
    history.push(URLS.START);
  };

  const handleChangeCompany = e => {
    const company = _.find(companies, ['cdEmpresa', Number(e.target.value)]);
    setCompanySelected(company);
  };

  const goToLogin = async () => {
    dispatch(showLoading());
    dispatch(setFromLogin(false));
    dispatch(clearServices());
    await logOut(dispatch);
    history.push(URLS.LOGIN);
    dispatch(hideLoading());
  };

  if (loading) return <></>;

  return (
    <div className={classes.container}>
      <Card className={classes.boxLogin}>
        <CardContent className={classes.content}>
          <Button className={classes.backButton} onClick={() => goToLogin()}>
            <KeyboardArrowLeft />
            <FormattedMessage id="LABELS.COMMONS.BACK" />
          </Button>
          <img className={classes.logo} src={logo} alt="logo" />

          <Formik
            initialValues={{}}
            validateOnBlur={false}
            validateOnChange={false}
            onSubmit={values => {
              handleSelectCompany();
            }}
          >
            {({ errors }) => {
              return (
                <Form>
                  <Box maxWidth={400} padding={4}>
                    <Grid container spacing={3}>
                      <Grid
                        item
                        xs={12}
                        className={[classes.boxRecoveryInfo, classes.textBlue].join(' ')}
                      >
                        <h2 className={classes.subtitle}>
                          <FormattedMessage id="LABELS.LOGIN.COMPANY_SELECT" />
                        </h2>
                        <p className={classes.observation}>
                          <FormattedMessage id="LABELS.LOGIN.COMPANY_SELECT_OBS" />
                        </p>
                      </Grid>
                      <Grid item xs={12} className={classes.boxTextField}>
                        <BusinessIcon className={classes.icone} color="disabled" />
                        <FormControl variant="filled" margin="dense" fullWidth>
                          <InputLabel htmlFor="empresa">
                            <FormattedMessage id="LABELS.COMMONS.COMPANY" />
                          </InputLabel>
                          <Field
                            name="empresa"
                            id="empresa"
                            native
                            as={Select}
                            onChange={e => handleChangeCompany(e)}
                          >
                            <option aria-label="None" value="" />
                            {companies.map((company, index) => {
                              return (
                                <option key={index} value={company.cdEmpresa}>
                                  {company.cdEmpresa} -{' '}
                                  {company.nmCompleto ? company.nmCompleto : company.deRazaoSocial}
                                </option>
                              );
                            })}
                          </Field>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} className={classes.item}>
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          className={classes.loginButton}
                        >
                          <FormattedMessage id="LABELS.COMMONS.SELECT" />
                          <NearMeIcon className={classes.iconSend} />
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Form>
              );
            }}
          </Formik>
        </CardContent>
      </Card>
    </div>
  );
}

export default injectIntl(SelectCompany);
